import React from 'react'
import { Box, Flex } from 'grid-styled'
import { utils } from 'alelo-logic'

import { Content, Span, Title, VehicleBar } from './styles'

import { currency, total } from './data.json'

const InvoiceDetailHeaderAmount = ({ amount }) => {
  return (
    <VehicleBar>
      <Content>
        <Flex align="center" justify="space-between">
          <Box width={[1, 2 / 12]} />
          <Box pl={[0, 20]} width={[1, 4 / 12]} />
          <Box pl={[0, 20]} width={[1, 4 / 12]} />
          <Box pl={[0, 20]} width={[1, 2 / 12]}>
            <Span>
              {total} ({currency})
            </Span>
            <Title id="detalhe_fatura_valor_total_transacoes">
              {utils.currencyParser(amount, currency)}
            </Title>
          </Box>
        </Flex>
      </Content>
    </VehicleBar>
  )
}

export default InvoiceDetailHeaderAmount



// WEBPACK FOOTER //
// ./src/app/elements/InvoiceDetailsHeaderAmount/index.js